import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

@customElement('phoenix-embed-fallback')
export default class PhoenixEmbedFallback extends LitElement {
    @state()
    canLoadFallback: Boolean = false;

    @property({ type: String })
    provider: string = '';

    @property({ type: String })
    url: string = '';

    public loadFallback() {
        this.canLoadFallback = true;
    }

    static get styles() {
        return css`
            .m-embed-fallback {
                background-color: var(--background-color, #e2f2f6);
                color: var(--text-color, #000000);
                display: block;
                font-size: 1rem;
                text-align: center;
                padding: 50% 1rem 50% 1rem;
                height: var(--embed-height, 'inherit');
            }
        `;
    }

    render() {
        return this.canLoadFallback
            ? html`<div class="m-embed-fallback">
                  <p>Oops! We're unable to load this content right now.</p>
                  <p>
                      View it directly on
                      <a onclick="return phoenixTrackClickEvent(this, event);" href="${this.url}">
                          ${this.provider}</a
                      >.
                  </p>
              </div>`
            : html`<slot></slot>`;
    }
}
